import { blindIndex, type IndexKind } from '../../shared/contentCrypto';
import { getContentKeyInfo } from './contentKey';

/**
 * Kişi ve şirket eşleştirmesi için arama özeti (kör indeks, veri koruma programı Faz 4).
 * Şifreli e-posta, alan adı ve ad üzerinde arama yapılamadığı için eşleştirme
 * `people.email_hash`, `people.name_hash`, `companies.domain_hash`, `companies.name_hash`
 * sütunlarıyla yapılır (migration 0043).
 */
export type Indexer = (kind: IndexKind, value: string | null | undefined) => Promise<string | null>;

/**
 * null: kullanıcının içerik anahtarı yok (şifreleme hiç açılmamış) — eşleştirme düz
 * değerlerle yapılır, özet yazılmaz (sunucudaki bakım işi sonra doldurur).
 * Şifreleme durumu hiç öğrenilemiyorsa hata fırlatır: anahtarsız eşleştirme şifreli
 * kayıtları göremez ve çift kişi açardı.
 */
export async function getIndexer(userId: string): Promise<Indexer | null> {
  const info = await getContentKeyInfo(userId);
  const key = info.key;
  if (!key) return null;
  return async (kind, value) => (value ? (await blindIndex(key, kind, value)) || null : null);
}
